module.exports = __webpack_public_path__ + "img/gb13871-92-20x40x7.prt.dda3309b.jpg";